export const HEADER_CELL_HEIGHT = 32
export const ROW_HEIGHT = 32 // 行高

export const LTR = 'ltr'
export const RTL = 'rtl'
export const RTL_OFFSET_NAG = 'negative'
export const RTL_OFFSET_POS_ASC = 'positive-ascending'
export const RTL_OFFSET_POS_DESC = 'positive-descending'
export const MIN_COLUMN_WIDTH = 40
export const MIN_ROW_HEIGHT = 32

export const MAIN_TABLE = 'main-table'
export const LEFT_TABLE = 'left-table'
export const RIGHT_TABLE = 'right-table'
export const BORDER_VALUE = 2
export const INTERNAL_ROW_KEY = '_id'
export const FIXD_SHOW_INDEX = 'fixd'
export const TABLE_MODE = {
  CONTENT: 'content',
  DEFAULT: 'default'
}


export const TABLE_CLASS_NAMES = {
  root: 'kye-table-v2__root'
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/config/table.js